import React, { useMemo } from 'react';
import {
    OrderAdjustmentOrderSaleInputQuery,
    useOrderAdjustmentGetOrderSaleLazyQuery,
    useOrderAdjustmentOrderSaleInputQuery,
} from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import {
    IOrderAdjustment,
    ORDER_ADJUSTMENT_TYPE_DEVOLUCION_ID,
    ORDER_SALE_ADJUSTMENT_PRODUCTS,
    ORDER_SALE_PRODUCTS,
} from '../order-adjustment-form';
import { useFormContext, useWatch } from 'react-hook-form';
import {
    FIELD_LABELS,
    formatFloat,
    shortLabel,
} from '../../../../../../../helpers';

const ORDER_ADJUSTMENT_TYPE_ID: keyof IOrderAdjustment =
    'order_adjustment_type_id';

export function OrderSaleInput() {
    const { data: dataOrderSales } = useOrderAdjustmentOrderSaleInputQuery();
    const [query] = useOrderAdjustmentGetOrderSaleLazyQuery();
    const rx = useFormContext();

    const INPUT_NAME: keyof IOrderAdjustment = 'order_sale';

    const order_adjustment_type_id = useWatch({
        name: ORDER_ADJUSTMENT_TYPE_ID,
    }) as IOrderAdjustment['order_adjustment_type_id'];

    // Same label the Transferencias sale selector uses: the order code (with
    // invoice folio, via compound_order_code) plus the sale's total, so the
    // user can identify the sale without opening it. Display-only field;
    // selection still keys off `id`.
    const sales = useMemo(() => {
        const rawSales: OrderAdjustmentOrderSaleInputQuery['getOrderSales'] =
            dataOrderSales?.getOrderSales || [];
        return rawSales.map((sale) => ({
            ...sale,
            option_label: `${sale.compound_order_code} ($${formatFloat(
                sale.total_with_tax || 0,
            )})`,
        }));
    }, [dataOrderSales]);

    return order_adjustment_type_id === ORDER_ADJUSTMENT_TYPE_DEVOLUCION_ID ? (
        <RhSingleAutocomplete
            itemText={'option_label'}
            itemValue={'id'}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.order_sale_id)}
            options={sales}
            returnObject
            onChange={async (osp: IOrderAdjustment['order_sale']) => {
                if (osp && osp.id) {
                    const { data } = await query({
                        variables: {
                            OrderSaleId: osp.id,
                        },
                    });
                    if (data && data.getOrderSale) {
                        const {
                            order_sale_products,
                            order_adjustment_products,
                        } = data.getOrderSale;
                        rx.setValue(ORDER_SALE_PRODUCTS, order_sale_products);
                        rx.setValue(
                            ORDER_SALE_ADJUSTMENT_PRODUCTS,
                            order_adjustment_products,
                        );
                    }
                }
            }}
        />
    ) : null;
}
